import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import backgroundImage from '../../assets/images/wallpaper.jpg';
import ProductMark from '@/components/ProductMark';
import { PRODUCT_NAME, PRODUCT_TAGLINE } from '@/config/product';
import { getAntdTheme } from '@/themes/antd-theme';

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

const AuthWrapper = ({ children }) => {
  // Force light mode for login page
  useEffect(() => {
    const root = document.documentElement;
    const wasDark = root.classList.contains('dark');

    // Remove dark class when login page mounts
    root.classList.remove('dark');

    // Restore dark class when login page unmounts (if it was dark before)
    return () => {
      if (wasDark) {
        root.classList.add('dark');
      }
    };
  }, []);

  // Get light theme configuration
  const lightTheme = getAntdTheme(false);

  return (
    <ConfigProvider theme={lightTheme}>
  <div className="relative min-h-screen w-full flex items-center justify-end">
    {/* Full Background Image */}
    <img
      src={backgroundImage}
      alt="Background"
      className="absolute inset-0 w-full h-full object-cover"
      style={{ zIndex: 0 }}
    />

    {/* Subtle Overlay */}
    <div
      className="absolute inset-0"
      style={{
        zIndex: 1,
        background: 'linear-gradient(to right, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.5) 100%)',
      }}
    />

    {/* Top Header */}
    <div
      className="absolute top-0 left-0 right-0 z-20 flex items-center justify-between px-6 py-4"
      style={{
        background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, transparent 100%)',
      }}
    >
      {/* Product lockup */}
      <div className="flex items-center gap-4">
        <ProductMark size={56} className="rounded-xl drop-shadow-lg" />
        <div>
          <div className="text-white text-3xl font-bold tracking-tight drop-shadow-lg">{PRODUCT_NAME}</div>
          <div className="hidden sm:block text-white/80 text-sm tracking-wider">{PRODUCT_TAGLINE}</div>
        </div>
      </div>
    </div>

    {/* Login Form - Right Side */}
    <div className="relative z-10 w-full lg:w-1/2 min-h-screen flex items-center justify-center p-6">
      <div
        className="w-full max-w-md bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8"
        style={{
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
        }}
      >
        {/* Mobile Branding */}
        <div className="lg:hidden flex flex-col items-center text-center mb-6">
          <ProductMark size={44} className="rounded-xl mb-2" />
          <h1 className="text-2xl font-bold text-gray-800 tracking-tight">{PRODUCT_NAME}</h1>
          <p className="text-sm text-gray-500 tracking-wider">{PRODUCT_TAGLINE}</p>
        </div>

        {children}

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-gray-400 text-xs">
            © {new Date().getFullYear()} Nexgensis. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  </div>
  </ConfigProvider>
  );
};

AuthWrapper.propTypes = {
  children: PropTypes.node,
};

export default AuthWrapper;
